export const REFERRER_BONUS_PERCENT = 15;
export const REFEREE_CASHBACK_PERCENT = 10;
export const POINTS_PER_RUBLE = 1;
export const MAX_POINTS_DISCOUNT_PERCENT = 50;

export const REFERRAL_CODE_LENGTH = 8;
export const REFERRAL_CODE_PATTERN = /^[A-Z0-9]{8}$/;

export function normalizeReferralCode(code) {
    return String(code ?? '')
        .trim()
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
}

export function formatReferralCode(code) {
    return normalizeReferralCode(code);
}

export function isValidReferralCodeFormat(code) {
    return REFERRAL_CODE_PATTERN.test(normalizeReferralCode(code));
}

export function sanitizeReferralCodeInput(value, maxLength = REFERRAL_CODE_LENGTH) {
    return normalizeReferralCode(value).slice(0, maxLength);
}
